// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2bq8F","cell":"ColumnAccessor_cell__1a_tz","firstCellAccent":"ColumnAccessor_firstCellAccent__ADLn0"};